export default function RequiredInd() {
  return <span className="text-danger">*</span>
}
